<template>
  <div>
    <template v-if="questionnaire.enabled_all_orgs">
      <span class="text-green-600">All customers</span>
    </template>
    <template v-else>
      <div class="flex items-center">
        <CustomerDisplay
          v-if="enabledOrganisations.length > 0"
          :org="enabledOrganisations[0]"
          :small="true"
        />
        <button
          v-if="enabledOrganisations.length > 1 && !showAll"
          class="ml-2 text-purple-600 underline"
          @click="toggleShowAll"
        >
          +{{ enabledOrganisations.length - 1 }} more
        </button>
      </div>
      <div
        v-if="showAll"
        class="mt-2"
      >
        <div
          v-for="org in enabledOrganisations.slice(1)"
          :key="org.uuid"
          class="mt-1"
        >
          <CustomerDisplay
            :org="org"
            :small="true"
          />
        </div>
        <button
          class="mt-2 text-purple-600 underline"
          @click="toggleShowAll"
        >
          See less
        </button>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
  import {
    type SuperUserQuestionnaire as Questionnaire,
    type SuperUserOrganisation as Organisation
  } from '@/types/generated'
  import { computed, ref } from 'vue'
  import CustomerDisplay from '@/components/admin/CustomerDisplay.vue'

  const props = defineProps({
    organisations: {
      type: Array as () => Organisation[],
      required: true
    },
    questionnaire: {
      type: Object as () => Questionnaire,
      required: true
    }
  })

  const enabledOrganisations = computed(() => {
    return props.organisations.filter((org) =>
      props.questionnaire?.enabled_custom_orgs.includes(org.uuid)
    )
  })

  const showAll = ref(false)

  const toggleShowAll = () => {
    showAll.value = !showAll.value
  }
</script>
